import React from "react";

const AppLogo: React.FC = () => {
  return <img src={require("./ProductAppLogo.png")} alt="" />;
};

export default AppLogo;
